// extracted by mini-css-extract-plugin
export default {"footer":"h1UqX","mobileFooter":"vFshS","container":"hzJe1"};